import React, { SVGProps } from 'react';

export default ({ ...props }: SVGProps<SVGSVGElement>) => (
  <svg {...props} viewBox="0 0 33 51" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M15.911 45.9531C14.253 44.8566 13.0283 43.2172 12.4471 41.3162L5.30246 17.9471C5.30246 17.9471 6.04182 5.16931 9.92162 3.98314C13.8014 2.79697 21.5596 12.9768 21.5596 12.9768L28.9451 37.1335C29.375 38.5397 29.3952 40.0393 29.0035 41.4566V41.4566C28.2985 44.0068 26.339 46.02 23.8087 46.7936L23.1356 46.9994C20.6919 47.7465 18.0423 47.3628 15.911 45.9531V45.9531Z" stroke="currentColor" strokeWidth="2" />
    <path d="M11.6789 28.5425L15.379 40.6451C15.379 40.6451 17.3473 44.4125 19.8105 44.8789" stroke="currentColor" />
  </svg>
);
